export default __webpack_public_path__ + "static/media/card_icon.038fad7a.svg";